import { shrpaApi } from "./axios";

// Types
import {
  SocialShareSummaryPayload,
  SocialMediaPostData,
  ImageSelectAIDebugData,
  UpdatePostScheduledAtPayload,
  UpdatePostScheduledAtResponse,
  SocialShareSummaryContentType,
  SocialPostCaptionAssistRequest,
  SocialPostCaptionAssistResponse,
} from "@contracts/shareStop";

export default {
  async loadSocialShareSummaryPayloadFromPostId(customerId: string, postId: string): Promise<SocialShareSummaryPayload> {
    const uri = `/social/v2/${customerId}/summary-details/${postId}`;
    const { data } = await shrpaApi.get<SocialShareSummaryPayload>(uri);

    return data;
  },

  async loadSocialShareSummaryPayloadFromSummaryId(
    customerId: string,
    contentSummaryId: string,
    contentType: SocialShareSummaryContentType = SocialShareSummaryContentType.Photos
  ): Promise<SocialShareSummaryPayload> {
    const uri = `/social/v2/${customerId}/summary-details/summary/${contentSummaryId}?contentType=${encodeURIComponent(contentType)}`;
    const { data } = await shrpaApi.get<SocialShareSummaryPayload>(uri);

    return data;
  },

  async deletePost(pageId: string, postId: string, reasonText: string) {
    const config = { headers: { "Content-Type": "application/json" } };
    const uri = `/social/v2/${pageId}/posts/${postId}`;
    await shrpaApi.delete(uri, { data: JSON.stringify(reasonText), ...config });
  },

  async requestDownloadId(customerId: string, postId: string): Promise<string> {
    const uri = `/social/v2/${customerId}/posts/${postId}/download`;
    const { data } = await shrpaApi.get(uri);

    return data;
  },

  async updatePost(postData: SocialMediaPostData): Promise<SocialMediaPostData> {
    const uri = `/social/v2/${postData.customerId}/posts/${postData.id}`;
    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await shrpaApi.put(uri, JSON.stringify(postData), config);

    return data;
  },

  async updatePostScheduledAt(postData: SocialMediaPostData, localDateTime: string): Promise<UpdatePostScheduledAtResponse> {
    const uri = `/social/v2/${postData.customerId}/posts/${postData.id}/scheduled`;
    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await shrpaApi.put(uri, JSON.stringify({ localDateTime } as UpdatePostScheduledAtPayload), config);

    return data;
  },

  async generateCaptionAssist(customerId: string, calendarId: string, payload: SocialPostCaptionAssistRequest): Promise<SocialPostCaptionAssistResponse> {
    const uri = `/social/v2/${encodeURIComponent(customerId)}/${encodeURIComponent(calendarId)}/posts/caption-assist`;
    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await shrpaApi.post<SocialPostCaptionAssistResponse>(uri, JSON.stringify(payload), config);

    return data;
  },

  async getDebugInfo(customerId: string): Promise<Array<ImageSelectAIDebugData>> {
    const uri = `/social-generator/${customerId}/debug`;
    const { data } = await shrpaApi.get<Array<ImageSelectAIDebugData>>(uri);
    return data;
  },

  async rerunEvalsForPost(customerId: string, postId: string): Promise<string> {
    const uri = `/evals/${customerId}/posts/${postId}/re-run`;
    const { data } = await shrpaApi.put<string>(uri);
    return data;
  },

  async loadPostsByWeekKey(customerId: string, weekKey: string): Promise<Array<SocialMediaPostData>> {
    const uri = `/social/v2/${customerId}/posts/by-week/${encodeURIComponent(weekKey)}`;
    const { data } = await shrpaApi.get<Array<SocialMediaPostData>>(uri);

    return data;
  },
};
